module.exports = __webpack_public_path__ + "img/blue-Group 670.b48b5c58.svg";